module.exports = __webpack_public_path__ + "img/banner-area-fonecedor-institucional.0ebf8c05.png";